import type {SearchParams} from 'src/typings';
import type {SearchManager} from '../search-manager/search-manager';
import {getContext, hasContext, setContext} from 'svelte';
import {SearchManagerConnectableProxy} from 'src/features/search/search-manager/search-manager-connectable-proxy';

const SEARCH_CONTEXT_KEY = 'search-context';
const SEARCH_CONTEXT_CONNECTOR_KEY = 'search-context-connector';

export function setSearchContext<ITEM>(searchManager: SearchManager<ITEM>) {
    setContext(SEARCH_CONTEXT_KEY, searchManager);
}

export function getSearchContext<ITEM, PARAMS extends SearchParams = SearchParams>(): SearchManager<ITEM, PARAMS> {
    if (!hasContext(SEARCH_CONTEXT_KEY)) {
        throw new Error('You need to use this component within KpSearchContext component');
    }

    return getContext(SEARCH_CONTEXT_KEY);
}

export function getOrCreateSearchManagerProxyContext<ITEM, PARAMS extends SearchParams = SearchParams>(): SearchManagerConnectableProxy<ITEM, PARAMS> {
    if (hasContext(SEARCH_CONTEXT_CONNECTOR_KEY)) {
        return getContext<SearchManagerConnectableProxy<ITEM, PARAMS>>(SEARCH_CONTEXT_CONNECTOR_KEY);
    } else {
        return setContext(SEARCH_CONTEXT_CONNECTOR_KEY, new SearchManagerConnectableProxy<ITEM, PARAMS>());
    }
}

export function tryToConnectSearchManagerToProxy<ITEM, PARAMS extends SearchParams = SearchParams>(searchManager: SearchManager<ITEM, PARAMS>) {
    if (!hasContext(SEARCH_CONTEXT_CONNECTOR_KEY)) {
        return;
    }

    const proxy = getContext<SearchManagerConnectableProxy<ITEM, PARAMS>>(SEARCH_CONTEXT_CONNECTOR_KEY);
    proxy.connect(searchManager);
}

export function getSearchManagerProxyFromContext<ITEM, PARAMS extends SearchParams = SearchParams>(): SearchManagerConnectableProxy<ITEM, PARAMS> {
    if (!hasContext(SEARCH_CONTEXT_CONNECTOR_KEY)) {
        throw new Error('You need to use this component within KpSearchManagerProxyContextProvider component or use setupSearchManagerProxyContext in parent components');
    }
    return getContext<SearchManagerConnectableProxy<ITEM, PARAMS>>(SEARCH_CONTEXT_CONNECTOR_KEY);
}